import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { EnrichedAttributes } from "../../recommendation.types";

export const requestEnrichProduct = async (
  id: string
): Promise<EnrichedAttributes> => {
  return await instance.post(
    `${ApiRoutesRecommendation.Enrichment}/${encodeURIComponent(id)}/enrich`
  );
};
